import { InvalidVaultEntryError } from './invalid-vault-entry-error';
export class RevokedPublicKeyError extends InvalidVaultEntryError {
    constructor(entry) {
        super('Revoked public key used for signature', entry);
        this.name = 'RevokedPublicKeyError';
    }
}
